const globalModule = 'global'
const staffModule = 'staff'
const coursesModule = 'courses'
const codeTableModule = 'codeTable'
const courseAppFormModule = 'courseAppForm'
const courseAttendanceModule = 'courseAttendance'
const trainingTLModule = 'trainingTaskList'
const bdrhStaffModule = 'bdrhStaff'
// const subsidyTLModule = 'subsidyTaskList'
const workflowModule = 'workflow'
const eLeaveModule = 'eLeave'
const boxFileModule = 'boxFile'
const substituteModule = 'substitute'
const sickLeaveModule = 'sickLeave'
const attendanceModule = 'attendance'
const researchModule = 'research'
const docFlowModule = 'docFlow'
// const staffSettingModule = 'staffSetting'
const commonComponentModule = 'commonComponent'
const mapaModule = 'mapa'

export {
  globalModule,
  staffModule,
  coursesModule,
  codeTableModule,
  courseAppFormModule,
  courseAttendanceModule,
  trainingTLModule,
  bdrhStaffModule,
  // subsidyTLModule,
  workflowModule,
  eLeaveModule,
  boxFileModule,
  substituteModule,
  sickLeaveModule,
  attendanceModule,
  researchModule,
  docFlowModule,
  commonComponentModule,
  mapaModule
  // staffSettingModule
}
